<template>
    <div class="admin-panel">
        <fieldset>
            <legend>Admin notes</legend>

            <label-input
                label="Notes"
                type="textarea"
                v-model="person.notes.$model"
                name="notes"
            />
        </fieldset>

        <fieldset>
            <legend>Student information</legend>
            <div v-if="person.student.$model">
                <label-input
                    label="Member through"
                    type="date"
                    v-model="person.student.member_through.$model"
                    :validator="person.student.member_through"
                    error-message="Membership end date is required."
                    name="student[member_through]"
                />
                <label-input
                    label="Student deleted"
                    type="checkbox"
                    v-model="person.student.deleted.$model"
                />
                <input type="hidden" name="student[deleted]" :value="person.student.deleted.$model ? 1 : 0">
            </div>
            <div class="clearfix"></div>
            <i
                v-if="!person.student.$model"
                class="icon-add"
                @click="addStudentInfo"
                v-text="'Add student info'"
            />
            <i
                v-if="person.student.$model && person.student.justAdded.$model"
                class="icon-delete"
                @click="cancelAddStudentInfo"
                v-text="'Cancel adding student info'"
            />
        </fieldset>

        <fieldset id="instructorInfo">
            <legend>Instructor information</legend>
            <div v-if="person.instructor.$model">
<!--
                <label-input
                    label="Full description"
                    type="textarea"
                    v-model="person.instructor.descLong.$model"
                    :validator="person.instructor.descLong"
                    error-message=""
                    name="instructor[descLong]"
                />
-->
                <label-input
                    label="Full description"
                >
                    <template v-slot:custom>
                        <rich-text-editor v-model="person.instructor.descLong.$model" />
                    </template>
                </label-input>
                <input type="hidden" name="instructor[descLong]" v-model="person.instructor.descLong.$model">

                <label-input
                    label="Show instructor"
                    type="checkbox"
                    v-model="person.instructor.active.$model"
                />
                <input type="hidden" name="instructor[active]" :value="person.instructor.active.$model ? 1 : 0">

                <label-input
                    label="Instructor deleted"
                    type="checkbox"
                    v-model="person.instructor.deleted.$model"
                />
                <input type="hidden" name="instructor[deleted]" :value="person.instructor.deleted.$model ? 1 : 0">
            </div>
            <div class="clearfix"></div>
            <i
                v-if="!person.instructor.$model"
                class="icon-add"
                @click="addInstructorInfo"
                v-text="'Add instructor info'"
            />
            <i
                v-if="person.instructor.$model && person.instructor.justAdded.$model"
                class="icon-delete"
                @click="cancelAddInstructorInfo"
                v-text="'Cancel adding instructor info'"
            />
        </fieldset>

        <fieldset>
            <legend>Credit</legend>
            <label-input
                label="Credit"
                type="number"
                input-style="width: 8em !important;"
                v-model="person.credit.$model"
                name="credit"
            />
        </fieldset>
    </div>
</template>

<script>
import LabelInput from '../../_components/form/LabelInput';
import RichTextEditor from '../../_components/RichTextEditor';

export default {
    components: {
        LabelInput,
        RichTextEditor,
    },

    props: {
        person: {
            type: Object,
        },
    },

    data() {
        return {
            // myStudent: {},
            // myInstructor: {},
            // studentMemberThrough: '',
        };
    },

    watch: {
        // studentMemberThrough() {
        //     // if (!this.myStudent) {
        //     //     return;
        //     // }
        //     // this.myStudent.member_through = this.studentMemberThrough;
        //     if (!this.person.student) {
        //         return;
        //     }
        //     this.person.student.member_through.$model = this.studentMemberThrough;
        // },
        //
        // person: {
        //     deep: true,
        //     handler() {
        //         // if (!this.person.student) {
        //         //     this.studentMemberThrough = '';
        //         // }
        //         this.studentMemberThrough = this.person.student?.member_through?.$model.substring(0, 10);
        //     },
        // },

        // myStudent: {
        //     deep: true,
        //     handler() {
        //         this.person.student = this.myStudent ? Object.assign(this.myStudent) : null;
        //     },
        // },
        //
        // myInstructor: {
        //     deep: true,
        //     handler() {
        //         this.person.instructor = this.myInstructor ? Object.assign(this.myInstructor) : null;
        //     },
        // },
    },

    methods: {
        addStudentInfo() {
            // this.myStudent = Object.assign({
            //     member_through: '',
            //     deleted: false,
            //     justAdded: true,
            // });
            this.person.student.$model = Object.assign({
                member_through: '',
                deleted: false,
                justAdded: true,
            });
        },

        cancelAddStudentInfo() {
            // this.myStudent = null;
            // this.person.student = null;
            this.person.student.$model = null;
        },

        addInstructorInfo() {
            // this.myInstructor = Object.assign({
            //     descLong: '',
            //     active: true,
            //     deleted: false,
            //     justAdded: true,
            // });
            this.person.instructor.$model = Object.assign({
                descLong: '',
                active: true,
                deleted: false,
                justAdded: true,
            });
        },

        cancelAddInstructorInfo() {
            // this.myInstructor = null;
            // this.person.instructor = null;
            this.person.instructor.$model = null;
        },
    },

    created() {
        // this.myStudent = this.person.student && Object.assign({
        //     member_through: this.person.student?.member_through ?? '',
        //     deleted: this.person.student?.deleted ?? false,
        // });
        // this.studentMemberThrough = this.myStudent?.member_through.substring(0, 10);
        // this.studentMemberThrough = this.person.student.member_through.$model.substring(0, 10);

        // this.myInstructor = this.person.instructor && Object.assign({
        //     descLong: this.person.instructor?.descLong ?? '',
        //     active: this.person.instructor?.active ?? false,
        //     deleted: this.person.instructor?.deleted ?? false,
        // });
    },
}
</script>

<style lang="scss">
.admin-panel {
    .icon-add, .icon-delete {
        font-style: italic;
    }
    i {
        display: inline-block !important;
    }
}
</style>
